import { tabbable } from 'tabbable';

export function onLeaveLowerBound (multiselectRef, optionsCount, footerRef) {
    if (optionsCount) {
        multiselectRef.pointerSet(optionsCount);
    }

    if (footerRef.$el) {
        footerRef.$el.focus();
    } else {
        const focusableElements = tabbable(footerRef);

        if (focusableElements.length > 1) {
            focusableElements[focusableElements.length - 1].focus();
        }
    }
}
